<template>
  <span class="wx-launch-trigger">
    <wx-open-launch-weapp v-if="enabled && path && !omitUsername" class="wx-launch-trigger__tag" :username="username" :appid="appid"
      :path="path">
      <script type="text/wxtag-template" v-html="triggerTemplate"></script>
    </wx-open-launch-weapp>
    <wx-open-launch-weapp v-else-if="enabled && path" class="wx-launch-trigger__tag" :appid="appid" :path="path">
      <script type="text/wxtag-template" v-html="triggerTemplate"></script>
    </wx-open-launch-weapp>
    <span v-else-if="showFallback" class="wx-launch-trigger__fallback" @click.stop="$emit('click')"></span>
  </span>
</template>

<script>
export default {
  name: 'WxLaunchWeappTrigger',
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: '',
    },
    appid: {
      type: String,
      default: 'wxee55405953922c86',
    },
    username: {
      type: String,
      default: 'gh_eedd8c096654',
    },
    omitUsername: {
      type: Boolean,
      default: false,
    },
    templateWidth: {
      type: String,
      default: '100%',
    },
    templateHeight: {
      type: String,
      default: '100%',
    },
    center: {
      type: Boolean,
      default: false,
    },
    showFallback: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    triggerTemplate() {
      // 微信开放标签要求模板写在 wxtag-template 中，这里用字符串生成，统一复用不同尺寸场景。
      const centerStyle = this.center ? 'margin:0 auto;' : ''
      const style = `display:block;width:${this.templateWidth};height:${this.templateHeight};${centerStyle}`
      return `<div style="${style}"></div>`
    },
  },
}
</script>

<style scoped lang="scss">
.wx-launch-trigger,
.wx-launch-trigger__tag,
.wx-launch-trigger__fallback {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/WxLaunchWeappTrigger.vue